import { LocaleEnum as a } from "@systemeio/types";
const l = {
  [a.ENGLISH]: "EN",
  [a.FRENCH]: "FR",
  [a.SPANISH]: "ES",
  [a.ITALIAN]: "IT",
  [a.PORTUGUESE]: "PT",
  [a.DEUTSCH]: "DE",
  [a.DUTCH]: "NL",
  [a.RUSSIAN]: "RU",
  [a.JAPANESE]: "JP",
  [a.ARABIC]: "AR",
  [a.TURKISH]: "TR",
  [a.CHINESE]: "CH",
  [a.SWEDISH]: "SV",
  [a.ROMANIAN]: "RO",
  [a.CZECH]: "CS",
  [a.HUNGARIAN]: "HU",
  [a.SLOVAK]: "SK",
  [a.DANISH]: "DK",
  [a.INDONESIAN]: "ID",
  [a.POLISH]: "PL",
  [a.GREEK]: "EL",
  [a.SERBIAN]: "SR",
  [a.HINDI]: "HI",
  [a.NORWEGIAN]: "NO",
  [a.THAI]: "TH",
  [a.SLOVENIAN]: "SL",
  [a.UKRAINIAN]: "UA",
  [a.ALBANIA]: "SQ"
}, c = {
  [a.ENGLISH]: "English",
  [a.FRENCH]: "Français",
  [a.SPANISH]: "Español",
  [a.ITALIAN]: "Italiano",
  [a.PORTUGUESE]: "Português",
  [a.DEUTSCH]: "Deutsch",
  [a.DUTCH]: "Nederlands",
  [a.RUSSIAN]: "Русский",
  [a.JAPANESE]: "日本語",
  [a.ARABIC]: "عربي",
  [a.TURKISH]: "Türkçe",
  [a.CHINESE]: "中文(简体)",
  [a.SWEDISH]: "Svenska",
  [a.ROMANIAN]: "Română",
  [a.CZECH]: "Čeština",
  [a.HUNGARIAN]: "Magyar",
  [a.SLOVAK]: "Slovenský",
  [a.DANISH]: "Dansk",
  [a.INDONESIAN]: "Indonesian",
  [a.POLISH]: "Polski",
  [a.GREEK]: "Ελληνικά",
  [a.SERBIAN]: "Srpski",
  [a.HINDI]: "Hindi",
  [a.NORWEGIAN]: "Norsk",
  [a.THAI]: "ไทย",
  [a.SLOVENIAN]: "Slovenski",
  [a.UKRAINIAN]: "Український",
  [a.ALBANIA]: "Shqiptare"
}, p = {
  [a.ENGLISH]: "public_pages_purchase.locale.english",
  [a.FRENCH]: "public_pages_purchase.locale.french",
  [a.SPANISH]: "public_pages_purchase.locale.spanish",
  [a.ITALIAN]: "public_pages_purchase.locale.italian",
  [a.PORTUGUESE]: "public_pages_purchase.locale.portuguese",
  [a.DEUTSCH]: "public_pages_purchase.locale.german",
  [a.DUTCH]: "public_pages_purchase.locale.dutch",
  [a.RUSSIAN]: "public_pages_purchase.locale.russian",
  [a.JAPANESE]: "public_pages_purchase.locale.japanese",
  [a.CHINESE]: "public_pages_purchase.locale.chinese",
  [a.TURKISH]: "public_pages_purchase.locale.turkish",
  [a.ARABIC]: "public_pages_purchase.locale.arabic",
  [a.SWEDISH]: "public_pages_purchase.locale.swedish",
  [a.ROMANIAN]: "public_pages_purchase.locale.romanian",
  [a.CZECH]: "public_pages_purchase.locale.czech",
  [a.HUNGARIAN]: "public_pages_purchase.locale.hungarian",
  [a.SLOVAK]: "public_pages_purchase.locale.slovak",
  [a.DANISH]: "public_pages_purchase.locale.danish",
  [a.INDONESIAN]: "public_pages_purchase.locale.indonesian",
  [a.POLISH]: "public_pages_purchase.locale.polish",
  [a.GREEK]: "public_pages_purchase.locale.greek",
  [a.SERBIAN]: "public_pages_purchase.locale.serbian",
  [a.HINDI]: "public_pages_purchase.locale.hindi",
  [a.NORWEGIAN]: "public_pages_purchase.locale.norwegian",
  [a.THAI]: "public_pages_purchase.locale.thai",
  [a.SLOVENIAN]: "public_pages_purchase.locale.slovenian",
  [a.UKRAINIAN]: "public_pages_purchase.locale.ukrainian",
  [a.ALBANIA]: "public_pages_purchase.locale.albania"
};
export {
  l as localeLabels,
  p as localeLanguages,
  c as localeNames
};
